;(function (angular, _) {
  'use strict'

  class CategoriesListController {
    constructor (
      // Angular
      // Libs
      $uibModal, $state,
      // Managers
      CategoryManager,
      // Services
      ColumnService, PaginationModel, FilterService, CategoryService
      // Const
      // Resolved
    ) {
      this.$uibModal = $uibModal
      this.$state = $state
      this.categoryManager = CategoryManager
      this.columnService = ColumnService
      this.paginationModel = PaginationModel
      this.filterService = FilterService
      this.categoryService = CategoryService
    }

    $onInit () {
      this.columns = this.columnService.getColumns('categories')
      this.paginationModel.get('categoriesPagination').then((pagination) => {
        // Composant détruit avant la résolution : on retire tout de suite le watcher $rootScope
        if (this.destroyed) return pagination.destroy()
        this.pagination = pagination
        this.getList()
      })
    }

    $onDestroy () {
      // Retire le watcher $rootScope de la pagination créée par ce composant
      this.destroyed = true
      if (this.pagination) this.pagination.destroy()
    }

    getList () {
      this.pagination.search = this.filterService.sanitizeSearchTree(this.pagination.search, true)
      this.pagination.save()

      this.pagination.orderBy = this.pagination.orderBy || 'label'

      var query = this.categoryManager
        .query()
        .paginate(this.pagination.toQueryOptions())

      if (this.pagination.search) {
        query.setQuery(this.filterService.parseQueryTree(this.pagination.search))
      }

      var promise = this.categoryManager.get(query, { ignoreArchived: true })
      promise.then((data) => {
        this.pagination.totalElements = data.meta.total
        this.pagination.save()
        this.categories = data.data

        // Reset the pagination if we try to load page without results
        if (parseInt(data.meta.total) !== 0 && !data.data.length) {
          this.pagination.currentPage = 0
          this.getList()
        }
      })
    }

    deleteCategory (category) {
      return this.categoryService.deleteCategory(category).then(() => {
        this.$state.go('preferences', { tabIndex: this.active })
        this.$state.reload()
      })
    }

    editCategory (category) {
      return this.categoryService.editCategory(category).then(() => {
        this.$state.go('preferences', { tabIndex: this.active })
        this.$state.reload()
      })
    }

    sort (name) {
      this.reverse = (this.pagination.orderBy === name) ? !this.reverse : false
      this.pagination.orderBy = name
      this.pagination.reverse = this.reverse
      this.getList()
    }
  }

  CategoriesListController.$inject = [
    // Angular
    // Libs
    '$uibModal', '$state',
    // Managers
    'CategoryManager',
    // Services
    'ColumnService', 'PaginationModel', 'FilterService', 'CategoryService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.preferences')
    .component('categoryList', {
      bindings: {
        active: '=?'
      },
      templateUrl: '/app/modules/preferences/categories/components/categories-list/categories-list.template.html',
      controller: CategoriesListController
    })
})(window.angular, window._)
